import { createDeferredI18n } from "#/shared/composables/useI18n";

// Mirrors `frontend.event_checkout` in config/locales/frontend.en.yml. The bundle fetch resolves
// even when the request fails, and an unresolved key renders as the key itself, so these seed the
// instance: a failed fetch degrades to English rather than showing `review_cart_section_title` to
// a payer. The fetched bundle overwrites all of it, including a client's own overrides.
const FALLBACK_MESSAGES = {
  cart_step_title: "Cart",
  cart_step_preamble: "Cart summary",
  participant_step_title: "Participant",
  participant_section_indicator_title: "Participant",
  payment_step_title: "Payment",
  review_step_title: "Review",
  review_preamble: "Review your registration",
  review_contact_heading: "",
  review_cart_section_title: "Event",
  review_date_time_section_title: "Event",
  review_participant_section_title: "Participant",
  review_payment_section_title: "Payment",
  review_address_section_title: "",
};

// `sp-checkout` is a registered component rather than an app, so it has no plugin hook to install
// the instance on — the strings are read off the global composer directly.
export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "event_checkout" });

i18n.global.setLocaleMessage(i18n.global.locale.value, FALLBACK_MESSAGES);

/**
 * Translates an event checkout string. Keys are relative to `frontend.event_checkout`, which the
 * i18n endpoint serves as the message root, and resolve per client through that client's own
 * locale files.
 *
 * @param {String} key
 * @returns {String}
 */
export function t(key) {
  return i18n.global.t(key);
}
